/**
 * Scroll-based lazy loading for images and picture elements.
 * Supports both <img> and <picture> with <source> tags
 * Usage: 
 *   <img data-scroll-lazy data-src="..." data-srcset="..." data-sizes="..." ...>
 *   <picture>
 *     <source data-scroll-lazy data-srcset="..." data-sizes="..." type="image/webp">
 *     <img data-scroll-lazy ...>
 *   </picture>
 */
(function () {
  function loadElement(el) {
    if (!el || el.__scrollLazyLoaded) return;
    el.__scrollLazyLoaded = true;

    // Check if element is a source tag
    if (el.tagName === "SOURCE") {
      var srcset = el.getAttribute("data-srcset");
      var sizes = el.getAttribute("data-sizes");

      if (sizes) el.setAttribute("sizes", sizes);
      if (srcset) el.setAttribute("srcset", srcset);

      el.removeAttribute("data-srcset");
      el.removeAttribute("data-sizes");
      el.removeAttribute("data-scroll-lazy");
      return;
    }

    // Handle img tag
    var src = el.getAttribute("data-src");
    var srcset = el.getAttribute("data-srcset");
    var sizes = el.getAttribute("data-sizes");

    if (sizes) el.setAttribute("sizes", sizes);
    if (srcset) el.setAttribute("srcset", srcset);
    if (src) el.setAttribute("src", src);

    el.removeAttribute("data-src");
    el.removeAttribute("data-srcset");
    el.removeAttribute("data-sizes");
    el.removeAttribute("data-scroll-lazy");

    // If img is inside a picture, load all sources
    var picture = el.closest("picture");
    if (picture) {
      var sources = picture.querySelectorAll("source[data-scroll-lazy]");
      for (var i = 0; i < sources.length; i++) {
        loadElement(sources[i]);
      }
    }
  }

  function init() {
    // Find all images and sources with data-scroll-lazy
    var imgs = document.querySelectorAll("img[data-scroll-lazy]");
    if (!imgs || !imgs.length) return;

    if (!("IntersectionObserver" in window)) {
      // Fallback: load all immediately
      for (var i = 0; i < imgs.length; i++) loadElement(imgs[i]);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            loadElement(entry.target);
            io.unobserve(entry.target);
          }
        }
      },
      { rootMargin: "300px 0px", threshold: 0.01 }
    );

    for (var j = 0; j < imgs.length; j++) io.observe(imgs[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();


